import { IAgentCard } from '../../../types/agentCard';

export const getWebsiteHref = (website: string) => (website.startsWith('http') ? website : `http://${website}`);

export const getActivityCounter = (questionsCount: number, blogsCount: number, advicesCount: number) =>
  questionsCount + blogsCount + advicesCount;

export const getCompanyDescription = ({
  description,
  skills,
  companyName,
}: {
  description?: string;
  skills?: IAgentCard['skills'];
  companyName?: IAgentCard['companyName'];
}) => {
  const blocks = [];

  if (skills && skills.length > 0) {
    blocks.push({ label: 'Специализация', text: skills.join(', ') });
  }

  if (description) {
    blocks.push({ label: '', text: description });
  }

  if (companyName) {
    blocks.push({ label: '', text: companyName });
  }

  return blocks;
};
